import React from "react";
import {withStyles} from "@material-ui/core/styles";
import TreeItem from "@material-ui/lab/TreeItem";
import SearchInput from "./SearchInput";
import {TransitionComponent} from "./TreeUtils";

const StyledTreeItem = withStyles((theme) => ({
    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        marginLeft: 7,
        paddingLeft: 8,
        borderLeft: `1px dashed ${theme.palette.text.primary}`,
    },
    label: {
        '& $searchButton': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $searchButton': {
                visibility: 'visible'
            }
        }
    },
    searchButton: {
        display: 'flex',
        alignItems: 'center'
    }
}))((props) => {

    return (
        <TreeItem
            {...props}
            label={
                <div
                    className={props.classes.label}
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    {props.label}
                    {props.isRoot && (
                        <>
                            <div className={props.classes.searchButton}>
                                <SearchInput
                                    searchKey={props.searchKey} cssClass={props.classes.searchButton}/>
                            </div>
                        </>
                    )}
                </div>}
            TransitionComponent={TransitionComponent}
        />
    )
});
export default StyledTreeItem;